<template>
  <div class="save-to-box">
    <SelectedEmailAndAssignment 
      :emailData="currentEmail"
      :assignment="selectedAssignment"
      :initiallyCollapsed="false"
      @assignmentChanged="onAssignmentChanged"
    />
    
    <div class="header1">
      <span class="title">Select Box Folder</span>
      <div v-if="selectedFolder" class="selected-text">
        Selected: {{ selectedFolder.name }}
      </div>
    </div>
    <div class="folder-list">
      <BoxFolderPickerComponent
                        :assignmentData="selectedAssignment"
                        @folderSelected="onFolderSelected"
                        @closeModal="backToRequest"
                        @loaded="handleBoxLoadObject"
                      />
    </div>

    <v-text-field v-model="fileName" class="search-input mt-4" placeholder="File Name" variant="outlined" hide-details
      density="compact"></v-text-field>
    <div class="file-name-hint">File name will default to the email title</div>
    <!-- <span class="title upload-title">What to upload?</span>
    <div class="upload-options">
      <button :class="['option-btn', { selected: uploadOption === 'Email Only' }]"
              @click="setUploadOption('Email Only')">
        <IconProvider name="Mail" class="icon" />
        <span>Email Only
         </span>
      </button>
      <button :class="['option-btn', { selected: uploadOption === 'Attachments' }]"
              @click="setUploadOption('Attachments')">
        <IconProvider name="Paperclip" class="icon" />
        <span>Attachments</span>
      </button>
      <button :class="['option-btn', { selected: uploadOption === 'Both' }]"
              @click="setUploadOption('Both')">
        <IconProvider name="FileText" class="icon" />
        <span>Both</span>
      </button>
    </div> -->
    <div class="processing-options" v-if="config.processingOptions.markAsProcessed.visible">
      <p class="processing-options-title mt-2">Processing Options</p>
      <div class="checkbox-group">
        <!-- <label>
          <input type="checkbox" v-model="dsadsa" />
          Convert email to PDF </label
         > -->
        <!-- <label> -->
        <v-checkbox v-model="markAsProcessed" :label="config.processingOptions.markAsProcessed.label" color="#003f2d"
          hide-details density="compact" class="custom-checkbox"></v-checkbox>
      </div>
    </div>
    <IsLoadingComponent v-if="showLoading" />
  </div>
</template>

<script>
import SelectedAssignment from "./assignment/SelectedAssignment.vue";
import SelectedEmailAndAssignment from "@/components/commons/SelectedEmailAndAssignment.vue";
import { mapGetters, mapActions,mapState } from "vuex";
import IconProvider from "../commons/IconProvider.vue";
import { getFolderInfByFolderID } from "../../service/boxService.js";
import processingOptions from "../../mixins/processingOptions.js";
import IsLoadingComponent from "../IsLoadingComponent.vue";
import BoxFolderPickerComponent from "../BoxFolderPickerComponent.vue";
import { handleRecentActions } from "../../service/engagement.js";
import { ACTION_TYPES } from '@/constants';
import { markEmailAsCompleteNew } from '../../service/Actions.js';
import { startTiming, addProcessingTime } from '../../utils/metricsHelper.js'; 

export default {
  name: "SaveToBox",
  components: {
    SelectedAssignment,
    SelectedEmailAndAssignment,
    BoxFolderPickerComponent,
    IconProvider,
    IsLoadingComponent,
    SelectedEmailAndAssignment
  },
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [processingOptions],
  data() {
    return {
      search: this.currentEmail?.subject || '',
      folders: [],
      selectedFolder: null,
      uploadOption: null,
      markAsProcessed: true,
      showLoading: false,
      hasError: true,
      fileName: null,
      boxAccessObject: { hasAccess: false, isLoaded: false }
    };
  },
  watch: {
    isValidForSubmit: {
      handler(newValue) {
        this.$emit('isValidForSubmit', newValue);
      },
      immediate: true
    },
    selectedAssignment: {
      handler(newAssignment) {
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        const y = now.getFullYear();
        const m = pad(now.getMonth() + 1);
        const d = pad(now.getDate());
        const h = pad(now.getHours());
        const min = pad(now.getMinutes());
        const s = pad(now.getSeconds());
        const timestamp = `${y}${m}${d}_${h}${min}${s}`;
        const subject = this.currentEmail?.subject || '';
        if (newAssignment && newAssignment.code) {
          this.fileName = subject.length > 25
            ? subject.substring(0, 25) + "_" + newAssignment.code + "_" + timestamp
            : subject + "_" + newAssignment.code + "_" + timestamp;
        } else {
          this.fileName = '';
        }
      },
      immediate: false
    }
  },
  computed: {
    ...mapState({
      currentEmail: (state) => state.email.currentEmail,
    }),
    ...mapGetters({
      selectedAssignment: "assignments/selectedAssignment"
    }),
    isValidForSubmit() {
      const hasBoxAccess = this.boxAccessObject.isLoaded && this.boxAccessObject.hasAccess;
      const hasFolderSelected = this.selectedFolder !== null;
      const hasFileName = this.fileName && this.fileName.trim().length > 0;
      
      return hasBoxAccess && hasFolderSelected && hasFileName;
    }
  },
  methods: {
    ...mapActions({
      add: "notification/add",
      convertToEmlFormData: "email/convertToEmlFormData",
      uploadFiles: "assignments/uploadFiles",
      addMetricsData: "assignments/addMetricsData"
    }),
    onAssignmentChanged(assignment) {
      // Handle assignment change if needed
      console.log('Assignment changed:', assignment);
    },
    handleBoxLoadObject(boxObject) {
      console.log('Box Load Object:', boxObject);
      this.boxAccessObject = boxObject;
      this.showLoading = !boxObject.isLoaded;
    },
    onFolderSelected(folder) {
      console.log('selected Folder', folder)
      this.selectedFolder = folder
    },
    getBoxObject(boxObject) {
      console.log('Box Object:', boxObject);
    },
    backToRequest(event) {
      console.log('Back to request:', event);
      this.selectedFolder = null;
    },
    setUploadOption(option) {
      this.uploadOption = option;
    },
    getFolderName(id) {
      const folder = this.folders.find((f) => f.id === id);
      return folder ? folder.name : "";
    },
    async getFolderInfByFolderID(folderID) {
      const response = await getFolderInfByFolderID(folderID);
      this.folders = response.item_collection.entries.map((entry) => ({
        id: entry.id,
        name: entry.name,
        path: entry.path_collection
          ? entry.path_collection.entries.map((e) => e.name).join("/")
          : "",
      }));
    },
    getWorkFileId(value) {
      if (!value) return null;
      let arr;
      if (value.includes("?")) {
        let boxArr = value.split("?");
        arr = boxArr[0].split("/");
      } else {
        arr = value.split("/");
      }
    },
    async saveToBox() {
      if (!this.selectedFolder) {
        this.add({
          type: "error",
          message: "Please select a folder to save the quote.",
          timeout: 5
        });
        return;
      }
      
      // Start timing
      const startTime = startTiming();
      
      // Initialize metrics payload
      const metricsPayload = {
        entityId: this.selectedAssignment.viewEventId,
        fileId: this.selectedAssignment.code,
        actionTaken: ACTION_TYPES.SAVE_TO_BOX,
        status: 'Completed',
        folderId: this.selectedFolder.id,
      };

      let finalStatus = 'Completed';
      let errorMessage = null;

      try {
        console.log("save to box clicked");
        this.showLoading = true; // Set loading state to true
        const formData = await this.convertToEmlFormData();

        // Create main multipart form data
        let multiFormData = new FormData();

        const now = new Date()
        const pad = (n) => n.toString().padStart(2, '0')
        const y = now.getFullYear()
        const m = pad(now.getMonth() + 1)
        const d = pad(now.getDate())
        const h = pad(now.getHours())
        const min = pad(now.getMinutes())
        const s = pad(now.getSeconds())
        const timestamp = `${y}${m}${d}_${h}${min}${s}`
        const subject = this.currentEmail?.subject || '';
        const fileNm = subject.length > 25 ? subject.substring(0, 25)  + "_" + this.selectedAssignment.code + "_" + timestamp : subject + "_" + this.selectedAssignment.code + "_" + timestamp;
        // Add the EML file
        let document = formData.get("file");
        let documentNm = document.name.replace(
          /.*(?=\.eml$)/,
          fileNm
        );
        let documentName = (!this.fileName || this.fileName.trim() === '') ? documentNm : this.fileName + ".eml";
        let emlFile = new File([document], documentName, {
          type: document.type,
          lastModified: document.lastModified,
        });
        multiFormData.append("files", emlFile);

        // Add metadata
        multiFormData.append("folderName", this.selectedFolder.name);

        const config = {
          timeout: 0,
          maxContentLength: Infinity,
          maxBodyLength: Infinity,
        };
        //get folderId
        console.log(this.selectedFolder);
        let request = {
          folderId: this.selectedFolder.id,
          multiPartFormData: multiFormData,
          config: config,
        };

        let boxResponse = await this.uploadFiles(request);
        if (boxResponse && boxResponse.length > 0) {
          console.log("uploaded file successfully", boxResponse);
          await this.saveRecentActions();
          if (this.markAsProcessed) {
            // Mark email as complete with enhanced function - banner notification
            markEmailAsCompleteNew(
              'completeNotification',
              'File saved to Box successfully',
              undefined,
              true
            );
          }

          // Logic to save the quote to the selected folder
          this.add({
            type: "success",
            message: `File saved to ${this.selectedFolder.name} successfully.`,
            timeout: 5
          });
        }
      } catch (error) {
        console.error('Error in saveToBox:', error);
        finalStatus = 'Error';
        errorMessage = error.message;
        
        this.add({
          type: 'error',
          message: 'Failed to save file. Please try again.'
        });
      } finally {
        this.showLoading = false;
        this.closeDialog();
        
        // Single metrics call with processing time
        const finalMetricsPayload = addProcessingTime(startTime, metricsPayload, finalStatus, errorMessage);
        await this.addMetricsData(finalMetricsPayload);
      }
    },
    async saveRecentActions() {
      const payload =  {
        action: ACTION_TYPES.SAVE_TO_BOX,
        entityIds: [this.selectedAssignment.viewEventId],
        fileId: this.selectedAssignment.code,
        folderId: this.selectedFolder.id
      };
      await handleRecentActions(payload, ACTION_TYPES.SAVE_TO_BOX);
    },
    closeDialog() {
      this.$emit("close");
    },
    extractBoxFolderId(url) {
      // Handle both folder and file URLs from Box
      const matches = url.match(/box\.com\/(folder|f)\/(\d+)/);
      return matches ? matches[2] : null;
    },
    getModifiedBy(modifiedBy) {
      return 'BOXAPIAccess';
    },
    getModifiedOn(modifiedOn) {
      return 'Tue May 14 2024';
    },
    getFolderSize(size) {
      return "8.3 KB";
    }
  },
  mounted() {
    // Fetch initial folder information if needed
    const now = new Date()
        const pad = (n) => n.toString().padStart(2, '0')
        const y = now.getFullYear()
        const m = pad(now.getMonth() + 1)
        const d = pad(now.getDate())
        const h = pad(now.getHours())
        const min = pad(now.getMinutes())
        const s = pad(now.getSeconds())
        const timestamp = `${y}${m}${d}_${h}${min}${s}`
    const subject = this.currentEmail?.subject || '';
    this.fileName = subject.length > 25 ? subject.substring(0, 25) + "_" + this.selectedAssignment.code + "_" + timestamp : subject + "_" + this.selectedAssignment.code + "_" + timestamp;
    this.showLoading = true;
    if (this.selectedAssignment && this.selectedAssignment.workFileLink) {
      let workFileId = this.extractBoxFolderId(this.selectedAssignment.workFileLink);
      this.getFolderInfByFolderID(workFileId);
    }
  },
};
</script>

<style scoped>
.subheading {
      display: flex;
    flex: 0 0 50px;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px 0 25px;
    border-bottom: 1px solid #e8e8e8;
    border-top: 1px solid #e8e8e8;
    box-shadow: 0 4px 6px -2px rgba(51, 51, 51, .04);
}
.dot::before {
    padding-right: 3px;
    padding-left: 3px;
    font-size: 8px;
    vertical-align: middle;
    content: "•";
}
.modified-details {
  display: flex;
  font-family: Calibre-R;
  color: #767676;
  font-size: 11px;
}
.custom-checkbox {
  font-family: Calibre-R-Medium;
font-style: Regular;
vertical-align: middle;
font-size: 14px
}

.custom-checkbox :deep(label) {
  font-family: Calibre-R;
  font-size: 14px;
  margin-left: 8px;
}

.processing-options-title {
  font-family: Calibre-R;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  vertical-align: middle;
  color: #000;
}
.search-input {
  font-size: 14px !important;
}

/* Also target the input element specifically */
.search-input >>> input {
  font-size: 14px !important;
}

/* Alternative: Use deep selector for Vue 3 */
.search-input :deep(input) {
  font-size: 14px !important;
}

/* Target all text within the text field */
.search-input :deep(.v-field__input) {
  font-size: 14px !important;
  color: #000;
}

/* Target placeholder text */
.search-input :deep(.v-field__input input::placeholder) {
  font-size: 14px !important;
  color:#767676;
}

.file-name-hint {
  font-size: 11px;
  margin-left: 16px;
  margin-top: 0px;
  color: gray;
}
.save-to-box {
  /* margin-top: -15px; */
  font-family: 'Segoe UI', sans-serif;
}

.header1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  margin-top: 12px;
}

.title {
  font-family: Calibre-R;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0;
  vertical-align: middle;
  color: #000
}

.selected-text {
  color: #006a4d;
  font-size: 12px;
  font-weight: 500;
}

.folder-list {
  overflow-y: auto;
}

.check-icon {
  padding: 2px;
  background: #006a4d;
  border-radius: 50%;
  color: white !important;
  width: 20px;
  height: 20px;
}

.folder-item {
  display: flex;
  justify-content: space-between;

  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #E1E1E1;
  font-family: Calibre-R-Medium;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0px;
}

.folder-content {
  display: flex;
  align-items: center;
}

.folder-item:last-child {
  border-bottom: none;
}

.folder-item:hover {
  background-color: #f3f3f3;
}

.folder-item.selected {
  background-color: #e0e8e5;
}

.folder-icon {
  color: #666;
  margin-right: 10px;
  font-size: 20px;
}

.check-icon {
  color: #107c10;
  font-size: 16px;
}

.folder-info {
  flex: 1;
  top: 2.5px;
  position: relative;
}

.folder-name {
  font-family: Calibre-R;
  font-weight: 500;
  margin-bottom: 2px;
  font-size: 12px;
  white-space: nowrap;
  color: #222222;
  text-overflow: ellipsis;
}

.folder-name.selected {
  color: #006a4d;
}
.folder-path {
  font-size: 12px;
  color: #666;
}

.upload-title {
  margin: 12px 0px 12px 0px;
  display: block;
  font-weight: 600;
}

.upload-options {
  display: flex;
  gap: 8px;
}

.option-btn {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  gap: 8px;
}

.option-btn:hover {
  background-color: #f3f3f3;
}

.option-btn.selected {
  background-color: #eaf6ff;
  border-color: #333;
}

.option-btn i {
  font-size: 20px;
  color: #666;
}

.option-btn.selected i {
  color: #0078d4;
}

.option-btn span {
  font-size: 14px;
}
.checkbox-group {
  display: flex;
  flex-direction: column;
  margin-left: 16px;
}
.icon {
  color: #003f2d;
}

.folder-list::-webkit-scrollbar:vertical {
  width: 4px;
}

/* Horizontal scrollbar (x-axis) */
.folder-list::-webkit-scrollbar:horizontal {
  height: 4px;
}

/* Combined - targets both vertical and horizontal */
.folder-list::-webkit-scrollbar {
  width: 4px;
  height: 4px; /* This is for horizontal scrollbar height */
}

.folder-list::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.folder-list::-webkit-scrollbar-thumb {
  background: #ababac;
  border-radius: 3px;
}

.folder-list::-webkit-scrollbar-thumb:hover {
  background: #ababac;
}

/* Corner where horizontal and vertical scrollbars meet */
.folder-list::-webkit-scrollbar-corner {
  background: #f1f5f9;
}
</style>
